// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import {
  getIsApplyCheckboxPromoOnPDPEnabled,
  getIsBuyMorePromoEnabled,
  getIsBuyMorePromoOnRecommendationEnabled,
  getIsUpdatedPromotionsDisplayEnabled,
  getIsOptimizedApplyCouponEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import PromotionsView from '../views/Promotions.view';
import {
  getServerTimeFromState,
  getPromotionsData,
  getUpdateCheckbox,
  getMemoisedCouponMap,
} from './Promotions.selectors';
import { removeAppliedPromotion, setAppliedPromotion } from './Promotions.action';
import BagPageActions from '../../../../features/CnC/BagPage/container/BagPage.actions';

const mapStateToProps = (state, ownProps) => {
  const { isRecommendation, isStyleWith, isRecommendationComponent } = ownProps;
  const fromRecommendation = isRecommendation || isStyleWith || isRecommendationComponent;
  return {
    isBuyMorePromoEnabled: fromRecommendation
      ? getIsBuyMorePromoOnRecommendationEnabled(state)
      : getIsBuyMorePromoEnabled(state),
    serverTime: getServerTimeFromState(state),
    promotionsData: getPromotionsData(state),
    isApplyCheckboxPromoOnPdp: getIsApplyCheckboxPromoOnPDPEnabled(state),
    updateCheckbox: getUpdateCheckbox(state),
    couponMap: getMemoisedCouponMap(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
    isOptimizedApplyCouponEnabled: getIsOptimizedApplyCouponEnabled(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    trackClickPromotion: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    applyCoupon: (payload) => dispatch(setAppliedPromotion(payload)),
    removeCoupon: (payload) => dispatch(removeAppliedPromotion(payload)),
    getCartDetailsOnPDP: (payload) => dispatch(BagPageActions.getNonCachedCartData(payload)),
  };
};

export default errorBoundary(connect(mapStateToProps, mapDispatchToProps)(PromotionsView));
